import LAYER_KEYS from 'config/layerKeys'
import { MenuDropDownButton } from '../components/MenuDropDownButton'
import { MenuItem } from '~/ui/Menu'
import { Icon } from '~/ui/Icon'
import { resolvePath, useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch } from '~/store/hooks'
import { setCurrentLayer } from '~/store/layers'
import { setActiveTool } from '~/store/tools'

export default function AnnotationsMenu() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  return (
    <MenuDropDownButton label="Annotations" icon="ruler">
      <MenuItem
        onAction={() => {
          dispatch(setCurrentLayer({ layerKey: LAYER_KEYS.DIMENSIONS }))
          dispatch(setActiveTool({ tool: 'DIMENSION_TOOL' }))
        }}
        variant="square"
      >
        <Icon name="ruler" size="14" />
        Measurement
      </MenuItem>
      <MenuItem
        onAction={() => {
          dispatch(setCurrentLayer({ layerKey: LAYER_KEYS.COMFORT_ZONES }))
          dispatch(setActiveTool({ tool: 'COMFORT_ZONE_TOOL' }))
        }}
        variant="square"
      >
        <Icon name="comfortZone" size="14" />
        Comfort Zone
      </MenuItem>
      <MenuItem onAction={() => navigate(resolvePath('upload-image/background', pathname))} variant="square">
        <Icon name="image" size="14" />
        Background Image
      </MenuItem>
    </MenuDropDownButton>
  )
}
